import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import { getKeycloak } from "@/restricted-library/plugins/keycloak";
import { STORAGE_KEYS } from "@/restricted-library/constants/storage";

import cities from "./store/addressHelper/cities";
import provinces from "./store/addressHelper/provinces";
import regions from "./store/addressHelper/regions";
import appointments from "./store/appointments";
import baseDialog from "./store/baseDialog";
import bookingDetails from "./store/bookingDetails";
import bookings from "./store/bookings";
import contacts from "./store/contacts";
import coverages from "./store/coverages";
import documents from "./store/documents";
import error from "./store/error";
import expost from "./store/expost";
import fondoEstPerTe from "./store/fondoEstPerTe";
import homepage from "./store/homepage";
import loading from "./store/loading";
import login from "./store/login";
import nestCommon from "./store/nestCommon";
import notifications from "./store/notifications";
import profile from "./store/profile";
import success from "./store/success";
import verifyContact from "./store/verifyContacts";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

const PERSISTENT_KEYS = [STORAGE_KEYS.LANGUAGE];

const storeModules = {
  login,
  coverages,
  contacts,
  homepage,
  profile,
  regions,
  provinces,
  cities,
  notifications,
  fondoEstPerTe,
  documents,
  loading,
  error,
  success,
  bookings,
  appointments,
  expost,
  nestCommon,
  bookingDetails,
  verifyContact,
  baseDialog
};

/**
 * VuexPersistence storage using localStorage
 * and all application modules
 */
const vuexSecure = new VuexPersistence({
  storage: window.localStorage
});

const state = {
  clientApplicationKey: process.env.VUE_APP_CLIENT_APPLICATION_KEY
};

const getters = {
  clientApplicationKey: state => state.clientApplicationKey
};

const mutations = {
  setClientApplicationKey(state, clientApplicationKey) {
    state.clientApplicationKey = clientApplicationKey;
  }
};

const actions = {
  async doLogout() {
    let kc = getKeycloak();
    try {
      if (kc && typeof kc.logout === "function") {
        await kc.logout({
          redirectUri: process.env.VUE_APP_KEYCLOAK_REDIRECT_URI_LOGOUT
        });
      } else {
        window.location.href = process.env.VUE_APP_KEYCLOAK_REDIRECT_URI_LOGOUT;
      }
    } catch (e) {
      console.error("Errore durante la fase di logout", e);
    }
  },
  async clearAll({ commit }) {
    for (const s in storeModules) {
      if (storeModules[s].mutations.reset != null) {
        await commit(`${s}/reset`);
      }
    }
    // clear local storage except for all the persistent keys
    // 1. recover all the persistent key/value from localStorage
    const values = {};
    PERSISTENT_KEYS.forEach(key => {
      values[key] = window.localStorage.getItem(key);
    });
    // 2. clean the localStorage
    window.localStorage.clear();
    // 3. set all the persistent key/value into localStorage
    PERSISTENT_KEYS.forEach(key => {
      if (values[key] !== null) {
        window.localStorage.setItem(key, values[key]);
      }
    });
  }
};

const store = new Vuex.Store({
  modules: storeModules,
  strict: debug,
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexSecure.plugin]
});

export default store;
